/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSEmail: any;
  AWSIPAddress: any;
  AWSJSON: any;
  AWSPhone: any;
  AWSTime: any;
  AWSTimestamp: any;
  AWSURL: any;
};

export type Account = {
  __typename?: 'Account';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  invoiceDetails?: Maybe<InvoiceDetails>;
  organizationalUnit?: Maybe<Scalars['String']>;
  owner?: Maybe<SystemUserResult>;
  serviceManager?: Maybe<SystemUserResult>;
  serviceNowAccount?: Maybe<ServiceNowAccountResult>;
  telephone?: Maybe<Scalars['String']>;
};

export type AccountFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
};

export type AccountSortingInput = {
  accountNumber?: InputMaybe<SortOrder>;
  createdOn?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type AccountsResult = {
  __typename?: 'AccountsResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<Account>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type Case = {
  __typename?: 'Case';
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sysCreatedBy?: Maybe<Scalars['String']>;
  sysCreatedOn?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  sysUpdatedBy?: Maybe<Scalars['String']>;
  sysUpdatedOn?: Maybe<Scalars['String']>;
  workNotes?: Maybe<Scalars['String']>;
};

export enum CaseCategory {
  Change = 'CHANGE',
  Incident = 'INCIDENT',
  SecurityIncident = 'SECURITY_INCIDENT',
  ServiceRequest = 'SERVICE_REQUEST'
}

export type CaseCreateInput = {
  accountNumber: Scalars['String'];
  category: CaseCategory;
  configurationItemSysId: Scalars['String'];
  description: Scalars['String'];
  priority?: InputMaybe<CasePriority>;
  severity?: InputMaybe<CaseSeverity>;
  subject: Scalars['String'];
};

export type CaseFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  contactId?: InputMaybe<FilterStringInput>;
  state?: InputMaybe<FilterStringInput>;
  sysCreatedOn?: InputMaybe<FilterDateInput>;
};

export enum CasePriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE'
}

export type CaseResult = {
  __typename?: 'CaseResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<Case>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum CaseSeverity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE'
}

export type CaseSortingInput = {
  sysCreatedOn?: InputMaybe<SortOrder>;
};

export type Change = {
  __typename?: 'Change';
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  impact?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sysCreatedBy?: Maybe<Scalars['String']>;
  sysCreatedOn?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  sysUpdatedBy?: Maybe<Scalars['String']>;
  sysUpdatedOn?: Maybe<Scalars['String']>;
  workNotes?: Maybe<Scalars['String']>;
};

export type ChangeFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  state?: InputMaybe<FilterStringInput>;
  sysCreatedOn?: InputMaybe<FilterDateInput>;
};

export type ChangeResult = {
  __typename?: 'ChangeResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<Change>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ChangeSortingInput = {
  sysCreatedOn?: InputMaybe<SortOrder>;
};

export type ChartData = {
  __typename?: 'ChartData';
  items?: Maybe<Array<Maybe<ChartDataItems>>>;
  name?: Maybe<Scalars['String']>;
};

export type ChartDataItems = {
  __typename?: 'ChartDataItems';
  datetime?: Maybe<Scalars['AWSDateTime']>;
  itemId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type ChartDataResult = {
  __typename?: 'ChartDataResult';
  metadata?: Maybe<Metadata>;
  result?: Maybe<Array<Maybe<ChartData>>>;
};

export type ChartMenu = {
  __typename?: 'ChartMenu';
  items?: Maybe<Array<Maybe<ChartMenuItems>>>;
  name?: Maybe<Scalars['String']>;
};

export type ChartMenuItems = {
  __typename?: 'ChartMenuItems';
  delay?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  history?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['String']>;
};

export type ChartMenuResult = {
  __typename?: 'ChartMenuResult';
  metadata?: Maybe<Metadata>;
  result?: Maybe<Array<Maybe<ChartMenu>>>;
};

export enum CloudProvider {
  Aws = 'AWS',
  Azure = 'AZURE'
}

export type ConfigurationItem = {
  __typename?: 'ConfigurationItem';
  cases?: Maybe<CaseResult>;
  cpuCount?: Maybe<Scalars['String']>;
  hostName?: Maybe<Scalars['String']>;
  installStatus?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  ram?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  sysClassName?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  uLogicalTag?: Maybe<Scalars['String']>;
  uPatchDaySchedule?: Maybe<Scalars['String']>;
  uPatchMonthSchedule?: Maybe<Scalars['String']>;
  uPatchTime?: Maybe<Scalars['String']>;
  uPatchWeekSchedule?: Maybe<Scalars['String']>;
  uPatchingDisabledReason?: Maybe<Scalars['String']>;
  uPatchingEnabled?: Maybe<Scalars['String']>;
  uSupportLevel?: Maybe<Scalars['String']>;
  uVmTechnology?: Maybe<Scalars['String']>;
};


export type ConfigurationItemCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<CaseSortingInput>>>;
};

export type ConfigurationItemFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  description?: InputMaybe<FilterStringInput>;
  hostName?: InputMaybe<FilterStringInput>;
  installStatus?: InputMaybe<FilterStringInput>;
  name?: InputMaybe<FilterStringInput>;
  os?: InputMaybe<FilterStringInput>;
  osVersion?: InputMaybe<FilterStringInput>;
  sysClassName?: InputMaybe<FilterStringInput>;
  sysId?: InputMaybe<FilterStringInput>;
  uReferenceIp?: InputMaybe<FilterStringInput>;
  uSupportLevel?: InputMaybe<FilterStringInput>;
  uVmTechnology?: InputMaybe<FilterStringInput>;
};

export type ConfigurationItemResult = {
  __typename?: 'ConfigurationItemResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<ConfigurationItem>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ConfigurationItemSortingInput = {
  installStatus?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  sysClassName?: InputMaybe<SortOrder>;
};

export type Contact = {
  __typename?: 'Contact';
  accountId?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  supportPortalAccess?: Maybe<Scalars['Boolean']>;
};

export enum ContactCaseCreateActionType {
  Create = 'CREATE',
  Disable = 'DISABLE',
  Edit = 'EDIT'
}

export type ContactCaseCreateInput = {
  accountNumber: Scalars['String'];
  action: ContactCaseCreateActionType;
  contactId?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  supportPortalAccess?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ContactCaseType>;
};

export enum ContactCaseType {
  Commercial = 'COMMERCIAL',
  Invoicing = 'INVOICING',
  Regular = 'REGULAR',
  Security = 'SECURITY',
  Technical = 'TECHNICAL'
}

export type ContactFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
};

export type ContactSortingInput = {
  emailAddress?: InputMaybe<SortOrder>;
};

export type ContactsResult = {
  __typename?: 'ContactsResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<Contact>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum Country {
  Be = 'BE',
  Dk = 'DK',
  Nl = 'NL'
}

export enum Currency {
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Sek = 'SEK',
  Usd = 'USD'
}

export type CustomersResult = {
  __typename?: 'CustomersResult';
  accounts?: Maybe<AccountsResult>;
  contacts?: Maybe<ContactsResult>;
};


export type CustomersResultAccountsArgs = {
  filters?: InputMaybe<AccountFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<AccountSortingInput>>>;
};


export type CustomersResultContactsArgs = {
  filters?: InputMaybe<ContactFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<ContactSortingInput>>>;
};

export type FilterBooleanInput = {
  operator?: InputMaybe<FilterEquals>;
  value: Scalars['Boolean'];
};

export type FilterChartDataInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  date: FilterDateTimeInput;
  itemId: FilterIntInput;
};

export type FilterChartMenuInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  host?: InputMaybe<FilterStringInput>;
  tags?: InputMaybe<Array<FilterTagInput>>;
};

export type FilterCloudProviderInput = {
  operator?: InputMaybe<FilterEnumOperator>;
  value: Array<CloudProvider>;
};

export type FilterCloudProviderInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<CloudProvider>;
};

export type FilterCountryInput = {
  operator?: InputMaybe<FilterEnumOperator>;
  value: Array<Country>;
};

export type FilterCountryInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<Country>;
};

export type FilterDateInput = {
  operator?: InputMaybe<FilterDateOperator>;
  value: Array<Scalars['AWSDate']>;
};

export enum FilterDateOperator {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  In = 'IN',
  LessThanEquals = 'LESS_THAN_EQUALS',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN'
}

export type FilterDateTimeInput = {
  operator?: InputMaybe<FilterDateTimeOperator>;
  value: Array<Scalars['AWSDateTime']>;
};

export enum FilterDateTimeOperator {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  LessThanEquals = 'LESS_THAN_EQUALS'
}

export enum FilterEnumOperator {
  Equals = 'EQUALS',
  In = 'IN',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN'
}

export enum FilterEquals {
  Equals = 'EQUALS'
}

export type FilterFloatInput = {
  operator?: InputMaybe<FilterNumericOperator>;
  value: Array<Scalars['Float']>;
};

export type FilterFloatInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<Scalars['Float']>;
};

export type FilterIdInput = {
  operator?: InputMaybe<FilterIdOperator>;
  value: Array<Scalars['ID']>;
};

export type FilterIdInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<Scalars['ID']>;
};

export enum FilterIdOperator {
  Equals = 'EQUALS',
  In = 'IN',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN'
}

export type FilterIntInput = {
  operator?: InputMaybe<FilterNumericOperator>;
  value: Array<Scalars['Int']>;
};

export type FilterIntInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<Scalars['Int']>;
};

export enum FilterNumericOperator {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  In = 'IN',
  LessThanEquals = 'LESS_THAN_EQUALS',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN'
}

export type FilterStringInput = {
  operator?: InputMaybe<FilterStringOperator>;
  value: Array<Scalars['String']>;
};

export type FilterStringInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<Scalars['String']>;
};

export enum FilterStringOperator {
  Equals = 'EQUALS',
  In = 'IN',
  Like = 'LIKE',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN'
}

export type FilterTagInput = {
  name: Scalars['String'];
  operator?: InputMaybe<FilterStringOperator>;
  value: Array<Scalars['String']>;
};

export enum FilterTagOperator {
  Equals = 'EQUALS',
  Exists = 'EXISTS',
  Like = 'LIKE',
  NotEquals = 'NOT_EQUALS',
  NotExists = 'NOT_EXISTS',
  NotLike = 'NOT_LIKE'
}

export type FilterTimeInput = {
  operator?: InputMaybe<FilterTimeOperator>;
  value: Array<Scalars['AWSTime']>;
};

export enum FilterTimeOperator {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  LessThanEquals = 'LESS_THAN_EQUALS'
}

export enum Iso2CountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Fx = 'FX',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  St = 'ST',
  Sv = 'SV',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tp = 'TP',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xi = 'XI',
  Ye = 'YE',
  Yt = 'YT',
  Yu = 'YU',
  Za = 'ZA',
  Zm = 'ZM',
  Zr = 'ZR',
  Zw = 'ZW'
}

export type Incident = {
  __typename?: 'Incident';
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sysCreatedBy?: Maybe<Scalars['String']>;
  sysCreatedOn?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  sysUpdatedBy?: Maybe<Scalars['String']>;
  sysUpdatedOn?: Maybe<Scalars['String']>;
  workNotes?: Maybe<Scalars['String']>;
};

export type IncidentFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  category?: InputMaybe<FilterStringInput>;
  state?: InputMaybe<FilterStringInput>;
  sysCreatedOn?: InputMaybe<FilterDateInput>;
};

export type IncidentResult = {
  __typename?: 'IncidentResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<Incident>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type IncidentSortingInput = {
  sysCreatedOn?: InputMaybe<SortOrder>;
};

export type InsightsResult = {
  __typename?: 'InsightsResult';
  newRelic?: Maybe<NewRelicResult>;
  powerBI?: Maybe<PowerBiResult>;
  zabbix?: Maybe<ZabbixResult>;
};


export type InsightsResultPowerBiArgs = {
  filters: PowerBiFilterInput;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  address?: Maybe<Address>;
  emailAddress?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export enum Language {
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN'
}

export type ListResult = {
  __typename?: 'ListResult';
  metadata: Metadata;
  result?: Maybe<Scalars['AWSJSON']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  conversationId: Scalars['ID'];
  message: Scalars['String'];
  statusCode: Scalars['Int'];
  statusText: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  serviceNowAccountUpdate: ServiceNowAccountResult;
  serviceNowCaseCreate: ServiceNowCaseResult;
  serviceNowContactCaseCreate: ServiceNowCaseResult;
};


export type MutationServiceNowAccountUpdateArgs = {
  input: ServiceNowAccountInput;
};


export type MutationServiceNowCaseCreateArgs = {
  input: CaseCreateInput;
};


export type MutationServiceNowContactCaseCreateArgs = {
  input: ContactCaseCreateInput;
};

export type NewRelicResult = {
  __typename?: 'NewRelicResult';
  nrql?: Maybe<NrqlResult>;
};


export type NewRelicResultNrqlArgs = {
  filters: NrqlFilterInput;
};

export type NrqlData = {
  __typename?: 'NrqlData';
  response?: Maybe<Scalars['AWSJSON']>;
};

export type NrqlFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  query: FilterStringInputExact;
};

export type NrqlResult = {
  __typename?: 'NrqlResult';
  metadata: Metadata;
  result?: Maybe<NrqlData>;
};

export type OperationsResult = {
  __typename?: 'OperationsResult';
  cases?: Maybe<CaseResult>;
  changes?: Maybe<ChangeResult>;
  configurationItems?: Maybe<ConfigurationItemResult>;
  incidents?: Maybe<IncidentResult>;
  problems?: Maybe<ProblemResult>;
};


export type OperationsResultCasesArgs = {
  filters?: InputMaybe<CaseFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<CaseSortingInput>>>;
};


export type OperationsResultChangesArgs = {
  filters?: InputMaybe<ChangeFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<ChangeSortingInput>>>;
};


export type OperationsResultConfigurationItemsArgs = {
  filters?: InputMaybe<ConfigurationItemFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<ConfigurationItemSortingInput>>>;
};


export type OperationsResultIncidentsArgs = {
  filters?: InputMaybe<IncidentFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<IncidentSortingInput>>>;
};


export type OperationsResultProblemsArgs = {
  filters?: InputMaybe<ProblemFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<Array<InputMaybe<ProblemSortingInput>>>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PowerBiEmbedToken = {
  __typename?: 'PowerBIEmbedToken';
  embedToken?: Maybe<Scalars['String']>;
  embedUrl?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['String']>;
};

export type PowerBiFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  reportName: PowerBiReportsInputExact;
};

export enum PowerBiReportsEnum {
  Invoices = 'INVOICES',
  LicenseReport = 'LICENSE_REPORT'
}

export type PowerBiReportsInputExact = {
  operator?: InputMaybe<FilterEquals>;
  value: Array<PowerBiReportsEnum>;
};

export type PowerBiResult = {
  __typename?: 'PowerBIResult';
  metadata: Metadata;
  result?: Maybe<PowerBiEmbedToken>;
};

export type Problem = {
  __typename?: 'Problem';
  comments?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sysCreatedBy?: Maybe<Scalars['String']>;
  sysCreatedOn?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  sysUpdatedBy?: Maybe<Scalars['String']>;
  sysUpdatedOn?: Maybe<Scalars['String']>;
  workNotes?: Maybe<Scalars['String']>;
};

export type ProblemFilterInput = {
  accountNumber?: InputMaybe<FilterStringInputExact>;
  state?: InputMaybe<FilterStringInput>;
  sysCreatedOn?: InputMaybe<FilterDateInput>;
};

export type ProblemResult = {
  __typename?: 'ProblemResult';
  metadata: Metadata;
  result?: Maybe<Array<Maybe<Problem>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProblemSortingInput = {
  sysCreatedOn?: InputMaybe<SortOrder>;
};

export type Query = {
  __typename?: 'Query';
  customers?: Maybe<CustomersResult>;
  insights?: Maybe<InsightsResult>;
  operations?: Maybe<OperationsResult>;
  user?: Maybe<UserResult>;
};

export type Result = {
  __typename?: 'Result';
  metadata: Metadata;
  result?: Maybe<Scalars['AWSJSON']>;
};

export enum Sla {
  BusinessCritical = 'BUSINESS_CRITICAL',
  MissionCritical = 'MISSION_CRITICAL',
  NonCritical = 'NON_CRITICAL',
  Unmanaged = 'UNMANAGED'
}

export type ServiceNowAccount = {
  __typename?: 'ServiceNowAccount';
  name?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  uSupportInformation?: Maybe<Scalars['String']>;
};

export type ServiceNowAccountInput = {
  accountNumber: Scalars['String'];
  sysId: Scalars['String'];
  uSupportInformation?: InputMaybe<Scalars['String']>;
};

export type ServiceNowAccountResult = {
  __typename?: 'ServiceNowAccountResult';
  metadata: Metadata;
  result?: Maybe<ServiceNowAccount>;
};

export type ServiceNowCaseResult = {
  __typename?: 'ServiceNowCaseResult';
  metadata: Metadata;
  result?: Maybe<Case>;
};

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SystemUser = {
  __typename?: 'SystemUser';
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
};

export type SystemUserResult = {
  __typename?: 'SystemUserResult';
  metadata: Metadata;
  result?: Maybe<SystemUser>;
};

export type UserResult = {
  __typename?: 'UserResult';
  accounts?: Maybe<AccountsResult>;
};

export type ZabbixResult = {
  __typename?: 'ZabbixResult';
  chartData?: Maybe<ChartDataResult>;
  chartMenu?: Maybe<ChartMenuResult>;
};


export type ZabbixResultChartDataArgs = {
  filters?: InputMaybe<FilterChartDataInput>;
};


export type ZabbixResultChartMenuArgs = {
  filters?: InputMaybe<FilterChartMenuInput>;
};

export type ServiceNowAccountUpdateMutationVariables = Exact<{
  input: ServiceNowAccountInput;
}>;


export type ServiceNowAccountUpdateMutation = { __typename?: 'Mutation', serviceNowAccountUpdate: { __typename?: 'ServiceNowAccountResult', metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string }, result?: { __typename?: 'ServiceNowAccount', sysId?: string | null } | null } };

export type ServiceNowCaseCreateMutationVariables = Exact<{
  input: CaseCreateInput;
}>;


export type ServiceNowCaseCreateMutation = { __typename?: 'Mutation', serviceNowCaseCreate: { __typename?: 'ServiceNowCaseResult', metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string }, result?: { __typename?: 'Case', sysId?: string | null } | null } };

export type ServiceNowContactCaseCreateMutationVariables = Exact<{
  input: ContactCaseCreateInput;
}>;


export type ServiceNowContactCaseCreateMutation = { __typename?: 'Mutation', serviceNowContactCaseCreate: { __typename?: 'ServiceNowCaseResult', metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string }, result?: { __typename?: 'Case', sysId?: string | null } | null } };

export type ListAccountWithOwnerAndManagerQueryVariables = Exact<{
  filters: AccountFilterInput;
}>;


export type ListAccountWithOwnerAndManagerQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersResult', accounts?: { __typename?: 'AccountsResult', totalCount?: number | null, result?: Array<{ __typename?: 'Account', accountId?: string | null, accountNumber?: string | null, accountName?: string | null, organizationalUnit?: string | null, telephone?: string | null, invoiceDetails?: { __typename?: 'InvoiceDetails', emailAddress?: string | null, vatNumber?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, postalCode?: string | null, street?: string | null } | null } | null, owner?: { __typename?: 'SystemUserResult', result?: { __typename?: 'SystemUser', emailAddress?: string | null, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null } | null } | null, serviceManager?: { __typename?: 'SystemUserResult', result?: { __typename?: 'SystemUser', emailAddress?: string | null, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null } | null } | null } | null> | null } | null } | null };

export type ListAccountWithServiceNowAccountQueryVariables = Exact<{
  filters: AccountFilterInput;
}>;


export type ListAccountWithServiceNowAccountQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersResult', accounts?: { __typename?: 'AccountsResult', totalCount?: number | null, result?: Array<{ __typename?: 'Account', accountNumber?: string | null, serviceNowAccount?: { __typename?: 'ServiceNowAccountResult', result?: { __typename?: 'ServiceNowAccount', sysId?: string | null, uSupportInformation?: string | null } | null } | null } | null> | null } | null } | null };

export type ListUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserAccountQuery = { __typename?: 'Query', user?: { __typename?: 'UserResult', accounts?: { __typename?: 'AccountsResult', result?: Array<{ __typename?: 'Account', accountNumber?: string | null, accountName?: string | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, statusCode: number, statusText: string } } | null } | null };

export type ListCaseQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<CaseFilterInput>;
  sorting?: InputMaybe<Array<InputMaybe<CaseSortingInput>> | InputMaybe<CaseSortingInput>>;
}>;


export type ListCaseQuery = { __typename?: 'Query', operations?: { __typename?: 'OperationsResult', cases?: { __typename?: 'CaseResult', totalCount?: number | null, result?: Array<{ __typename?: 'Case', comments?: string | null, number?: string | null, description?: string | null, priority?: string | null, state?: string | null, subject?: string | null, sysCreatedBy?: string | null, sysCreatedOn?: string | null, sysUpdatedBy?: string | null, sysUpdatedOn?: string | null, workNotes?: string | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type ListCaseByCiQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<ConfigurationItemFilterInput>;
  sorting?: InputMaybe<Array<InputMaybe<CaseSortingInput>> | InputMaybe<CaseSortingInput>>;
}>;


export type ListCaseByCiQuery = { __typename?: 'Query', operations?: { __typename?: 'OperationsResult', configurationItems?: { __typename?: 'ConfigurationItemResult', totalCount?: number | null, result?: Array<{ __typename?: 'ConfigurationItem', name?: string | null, cases?: { __typename?: 'CaseResult', totalCount?: number | null, result?: Array<{ __typename?: 'Case', comments?: string | null, number?: string | null, description?: string | null, state?: string | null, subject?: string | null, sysCreatedBy?: string | null, sysCreatedOn?: string | null, workNotes?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type ListChangesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<ChangeFilterInput>;
  sorting?: InputMaybe<Array<InputMaybe<ChangeSortingInput>> | InputMaybe<ChangeSortingInput>>;
}>;


export type ListChangesQuery = { __typename?: 'Query', operations?: { __typename?: 'OperationsResult', changes?: { __typename?: 'ChangeResult', totalCount?: number | null, result?: Array<{ __typename?: 'Change', number?: string | null, description?: string | null, impact?: string | null, priority?: string | null, state?: string | null, subject?: string | null, sysCreatedBy?: string | null, sysCreatedOn?: string | null, sysId?: string | null, sysUpdatedBy?: string | null, sysUpdatedOn?: string | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type ListCiQueryVariables = Exact<{
  filters?: InputMaybe<ConfigurationItemFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListCiQuery = { __typename?: 'Query', operations?: { __typename?: 'OperationsResult', configurationItems?: { __typename?: 'ConfigurationItemResult', totalCount?: number | null, result?: Array<{ __typename?: 'ConfigurationItem', cpuCount?: string | null, hostName?: string | null, installStatus?: string | null, ipAddress?: string | null, name?: string | null, os?: string | null, osVersion?: string | null, ram?: string | null, shortDescription?: string | null, sysClassName?: string | null, sysId?: string | null, uLogicalTag?: string | null, uPatchDaySchedule?: string | null, uPatchMonthSchedule?: string | null, uPatchTime?: string | null, uPatchWeekSchedule?: string | null, uPatchingDisabledReason?: string | null, uPatchingEnabled?: string | null, uSupportLevel?: string | null, uVmTechnology?: string | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type ListContactsQueryVariables = Exact<{
  filters?: InputMaybe<ContactFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListContactsQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersResult', contacts?: { __typename?: 'ContactsResult', totalCount?: number | null, result?: Array<{ __typename?: 'Contact', contactType?: string | null, emailAddress?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, mobilePhone?: string | null, supportPortalAccess?: boolean | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type ListIncidentsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<IncidentFilterInput>;
  sorting?: InputMaybe<Array<InputMaybe<IncidentSortingInput>> | InputMaybe<IncidentSortingInput>>;
}>;


export type ListIncidentsQuery = { __typename?: 'Query', operations?: { __typename?: 'OperationsResult', incidents?: { __typename?: 'IncidentResult', totalCount?: number | null, result?: Array<{ __typename?: 'Incident', number?: string | null, description?: string | null, priority?: string | null, state?: string | null, severity?: string | null, subject?: string | null, sysCreatedBy?: string | null, sysCreatedOn?: string | null, sysId?: string | null, sysUpdatedBy?: string | null, sysUpdatedOn?: string | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type NrqlQueryVariables = Exact<{
  filters: NrqlFilterInput;
}>;


export type NrqlQuery = { __typename?: 'Query', insights?: { __typename?: 'InsightsResult', newRelic?: { __typename?: 'NewRelicResult', nrql?: { __typename?: 'NrqlResult', result?: { __typename?: 'NrqlData', response?: any | null } | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null } | null };

export type GetPowerBiReportsQueryVariables = Exact<{
  filters: PowerBiFilterInput;
}>;


export type GetPowerBiReportsQuery = { __typename?: 'Query', insights?: { __typename?: 'InsightsResult', powerBI?: { __typename?: 'PowerBIResult', result?: { __typename?: 'PowerBIEmbedToken', embedToken?: string | null, embedUrl?: string | null, reportId?: string | null } | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type ListProblemsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<ProblemFilterInput>;
  sorting?: InputMaybe<Array<InputMaybe<ProblemSortingInput>> | InputMaybe<ProblemSortingInput>>;
}>;


export type ListProblemsQuery = { __typename?: 'Query', operations?: { __typename?: 'OperationsResult', problems?: { __typename?: 'ProblemResult', totalCount?: number | null, result?: Array<{ __typename?: 'Problem', number?: string | null, description?: string | null, priority?: string | null, state?: string | null, subject?: string | null, sysCreatedBy?: string | null, sysCreatedOn?: string | null, sysId?: string | null, sysUpdatedBy?: string | null, sysUpdatedOn?: string | null } | null> | null, metadata: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } } | null } | null };

export type ChartMenuQueryVariables = Exact<{
  filters?: InputMaybe<FilterChartMenuInput>;
}>;


export type ChartMenuQuery = { __typename?: 'Query', insights?: { __typename?: 'InsightsResult', zabbix?: { __typename?: 'ZabbixResult', chartMenu?: { __typename?: 'ChartMenuResult', result?: Array<{ __typename?: 'ChartMenu', name?: string | null, items?: Array<{ __typename?: 'ChartMenuItems', delay?: string | null, description?: string | null, history?: string | null, itemId?: string | null, name?: string | null, units?: string | null } | null> | null } | null> | null, metadata?: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } | null } | null } | null } | null };

export type ChartDataQueryVariables = Exact<{
  filters?: InputMaybe<FilterChartDataInput>;
}>;


export type ChartDataQuery = { __typename?: 'Query', insights?: { __typename?: 'InsightsResult', zabbix?: { __typename?: 'ZabbixResult', chartData?: { __typename?: 'ChartDataResult', result?: Array<{ __typename?: 'ChartData', name?: string | null, items?: Array<{ __typename?: 'ChartDataItems', value?: number | null, datetime?: any | null, itemId?: string | null } | null> | null } | null> | null, metadata?: { __typename?: 'Metadata', conversationId: string, message: string, statusCode: number, statusText: string } | null } | null } | null } | null };


export const ServiceNowAccountUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"serviceNowAccountUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceNowAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceNowAccountUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}}]}}]}}]}}]} as unknown as DocumentNode<ServiceNowAccountUpdateMutation, ServiceNowAccountUpdateMutationVariables>;
export const ServiceNowCaseCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"serviceNowCaseCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceNowCaseCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}}]}}]}}]}}]} as unknown as DocumentNode<ServiceNowCaseCreateMutation, ServiceNowCaseCreateMutationVariables>;
export const ServiceNowContactCaseCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"serviceNowContactCaseCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactCaseCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceNowContactCaseCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}}]}}]}}]}}]} as unknown as DocumentNode<ServiceNowContactCaseCreateMutation, ServiceNowContactCaseCreateMutationVariables>;
export const ListAccountWithOwnerAndManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAccountWithOwnerAndManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListAccountWithOwnerAndManagerQuery, ListAccountWithOwnerAndManagerQueryVariables>;
export const ListAccountWithServiceNowAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAccountWithServiceNowAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serviceNowAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"uSupportInformation"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ListAccountWithServiceNowAccountQuery, ListAccountWithServiceNowAccountQueryVariables>;
export const ListUserAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listUserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListUserAccountQuery, ListUserAccountQueryVariables>;
export const ListCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseSortingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"workNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCaseQuery, ListCaseQueryVariables>;
export const ListCaseByCiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCaseByCI"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurationItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseSortingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configurationItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"workNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCaseByCiQuery, ListCaseByCiQueryVariables>;
export const ListChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeSortingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListChangesQuery, ListChangesQueryVariables>;
export const ListCiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCI"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurationItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configurationItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpuCount"}},{"kind":"Field","name":{"kind":"Name","value":"hostName"}},{"kind":"Field","name":{"kind":"Name","value":"installStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"os"}},{"kind":"Field","name":{"kind":"Name","value":"osVersion"}},{"kind":"Field","name":{"kind":"Name","value":"ram"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sysClassName"}},{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"uLogicalTag"}},{"kind":"Field","name":{"kind":"Name","value":"uPatchDaySchedule"}},{"kind":"Field","name":{"kind":"Name","value":"uPatchMonthSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"uPatchTime"}},{"kind":"Field","name":{"kind":"Name","value":"uPatchWeekSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"uPatchingDisabledReason"}},{"kind":"Field","name":{"kind":"Name","value":"uPatchingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"uSupportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"uVmTechnology"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCiQuery, ListCiQueryVariables>;
export const ListContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactType"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"supportPortalAccess"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListContactsQuery, ListContactsQueryVariables>;
export const ListIncidentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListIncidents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentSortingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListIncidentsQuery, ListIncidentsQueryVariables>;
export const NrqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Nrql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NrqlFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newRelic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nrql"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NrqlQuery, NrqlQueryVariables>;
export const GetPowerBiReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPowerBiReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PowerBIFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"powerBI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"embedToken"}},{"kind":"Field","name":{"kind":"Name","value":"embedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPowerBiReportsQuery, GetPowerBiReportsQueryVariables>;
export const ListProblemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListProblems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProblemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProblemSortingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"problems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysCreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"sysUpdatedOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListProblemsQuery, ListProblemsQueryVariables>;
export const ChartMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChartMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterChartMenuInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zabbix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chartMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delay"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"units"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChartMenuQuery, ChartMenuQueryVariables>;
export const ChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterChartDataInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zabbix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chartData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusText"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChartDataQuery, ChartDataQueryVariables>;